module.exports = __webpack_public_path__ + "static/media/4_7.f4de6dd1.png";